import { TConfig, TGetAddOns } from '@@/interfaces';
import { excludeFalse } from '@@/utils/excludeFalse';

const ToyotaSCConfig: DeepPartial<TConfig> = {
  auto: {
    addOns: {
      getAddOns: ({ userFlow }: Parameters<TGetAddOns>[0]) =>
        excludeFalse([
          'towing_road_services',
          'loss_of_use',
          'ridesharing',
          userFlow === 'self-service' && 'loan_lease_payoff',
          'oem_parts',
          'new_car_replacement',
        ] as const),
    },
  },
};
export default ToyotaSCConfig;
